module.exports = __webpack_public_path__ + "static/media/loading4.94ced509.gif";